var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41265",
    "data-name": "Group 41265",
    transform: "translate(-558 -218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15662",
    "data-name": "Rectangle 15662",
    width: 20,
    height: 20,
    transform: "translate(558 218)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(559.25 219.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(0.684 0.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    d: "M-306.6,0a8.066,8.066,0,0,0-8.066,8.066,8.028,8.028,0,0,0,1.222,4.27l-1.222,3.8,3.8-1.222a8.028,8.028,0,0,0,4.27,1.222,8.066,8.066,0,0,0,8.066-8.066A8.066,8.066,0,0,0-306.6,0Z",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41264",
    "data-name": "Group 41264",
    transform: "translate(5.879 5.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1794",
    transform: "translate(2.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1796",
    d: "M0,0V5.742",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1798",
    transform: "translate(0 2.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1800",
    d: "M0,0H5.742",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddChat);
export default __webpack_public_path__ + "static/media/add-chat.24f8b1b373af41d9487cf14e20b79b4c.svg";
export { ForwardRef as ReactComponent };